import { render, staticRenderFns } from "./InformationRight.vue?vue&type=template&id=1bc63c4f&scoped=true&"
import script from "./InformationRight.vue?vue&type=script&lang=js&"
export * from "./InformationRight.vue?vue&type=script&lang=js&"
import style0 from "./InformationRight.vue?vue&type=style&index=0&id=1bc63c4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc63c4f",
  null
  
)

export default component.exports